// eslint-disable-next-line no-unused-vars
export default (element, data) => {
  const init = () => {};

  init();
};
